import {
  NotificationChannel,
  NotificationChannels,
} from '../../types/notifications';

export const getChannelText = (channel: NotificationChannel) => {
  switch (channel) {
    case NotificationChannels.EMAIL:
      return 'Email';
    case NotificationChannels.SMS:
      return 'SMS';
    case NotificationChannels.PUSH:
      return 'Push';
    default:
      return '';
  }
};

export const getChannelsString = (channels: NotificationChannel[]) => {
  const rank = {
    [NotificationChannels.SMS]: 0,
    [NotificationChannels.EMAIL]: 1,
    [NotificationChannels.PUSH]: 2,
  };
  return [...channels]
    .sort((a, b) => rank[a] - rank[b])
    .map(getChannelText)
    .join(', ');
};
